import { LOGO_BASE_URL } from '../../apiConfig';
import teamLogo from '../../images/team-logo.png';
import { Calendar, MapPin, Trophy } from 'lucide-react';
import { motion } from 'framer-motion';

function FixtureCard({ data }) {
    const isMobile = window.innerWidth <= 768;
    const accentYellow = '#E7C424';

    const styles = {
        card: {
            width: '100%',
            maxWidth: '512px',
            height: isMobile ? 'auto' : '212px',
            background: 'linear-gradient(180deg, #0812BB 0%, #000443 100%)',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.08)',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0px',
            background: 'transparent',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
        },
        dateBox: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        dateText: {
            fontFamily: 'var(--fontBody)',
            fontWeight: 600,
            fontSize: '14px',
            color: 'rgba(255,255,255,0.9)',
            margin: 0,
        },
        matchNum: {
            fontFamily: 'var(--fontDisplay)',
            fontWeight: 700,
            fontSize: '14px',
            color: accentYellow,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: 0,
        },
        body: {
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr',
            alignItems: 'center',
            padding: isMobile ? '12px 0' : '8px 0',
            flex: 1,
            gap: '12px',
        },
        teamBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            minWidth: 0,
        },
        logoBox: {
            width: '48px',
            height: '48px',
            background: '#ffffff',
            borderRadius: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px',
            boxSizing: 'border-box',
            border: '2px solid rgba(255,255,255,0.15)',
        },
        teamName: {
            fontFamily: 'var(--fontAnton)',
            fontWeight: 400,
            fontSize: isMobile ? '13px' : '16px',
            textAlign: 'center',
            margin: '8px 0 0 0',
            color: '#FFFFFF',
            textTransform: 'uppercase',
            lineHeight: 1.1,
            letterSpacing: '0.5px',
        },
        vsText: {
            fontFamily: 'var(--fontAnton)',
            fontSize: isMobile ? '28px' : '40px',
            fontWeight: 400,
            color: '#FFFFFF',
            opacity: 1,
            margin: 0,
            textShadow: '0 4px 20px rgba(0,0,0,0.5)',
        },
        footer: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 0 0 0',
            background: 'transparent',
            borderTop: '1px solid rgba(255,255,255,0.05)',
        },
        locationText: {
            fontFamily: 'var(--fontBody)',
            fontWeight: 500,
            fontSize: '13px',
            color: 'rgba(255,255,255,0.6)',
            margin: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }
    };

    return (
        <motion.div 
            whileHover={{ y: -5, boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}
            style={styles.card}
        >
            {/* Header */}
            <div style={styles.header}>
                <div style={styles.dateBox}>
                    <Calendar size={14} color={accentYellow} />
                    <p style={styles.dateText}>{data.match_date}</p>
                </div>
                <p style={styles.matchNum}>MATCH {data.id}</p>
                <div style={{
                    color: accentYellow,
                    padding: '2px 0',
                    fontSize: '11px',
                    fontWeight: 800,
                    textTransform: 'uppercase',
                }}>Upcoming</div>
            </div>

            {/* Body */}
            <div style={styles.body}>
                <div style={styles.teamBox}>
                    <div style={styles.logoBox}>
                        <img 
                            src={data.home_team_logo ? `${LOGO_BASE_URL}/${data.home_team_logo}` : teamLogo} 
                            alt={data.home_club_name} 
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                    <p style={styles.teamName}>{data.home_club_name}</p>
                </div>

                <p style={styles.vsText}>V/S</p>

                <div style={styles.teamBox}>
                    <div style={styles.logoBox}>
                        <img 
                            src={data.away_team_logo ? `${LOGO_BASE_URL}/${data.away_team_logo}` : teamLogo} 
                            alt={data.away_club_name} 
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                    <p style={styles.teamName}>{data.away_club_name}</p>
                </div>
            </div>

            {/* Footer */}
            <div style={styles.footer}>
                <MapPin size={14} color={accentYellow} />
                <p style={styles.locationText}>{data.ground_name}</p>
            </div>
        </motion.div>
    );
}

export default FixtureCard;